// extracted by mini-css-extract-plugin
export default {"wrapChart":"prospect-type-detail-module_wrapChart_lVjk2","flexRowCenter":"prospect-type-detail-module_flexRowCenter_Kq7ry","tag":"prospect-type-detail-module_tag_z64po"};